import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import type { State } from './type';
import { ProjectItem } from '../../queries/fragments/project';

const initialState: State = {
  loadingProjectsCarousel: true,
  projectsTotalCount: 0,
  projectsItems: [],
  currentKeyword: '',
  currentSourcePage: '',
};

const hydrate = createAction<{ search: State }>(HYDRATE);

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    updateLoadingProjectCarousel: (state, action: PayloadAction<boolean>) => {
      state.loadingProjectsCarousel = action.payload;
    },
    updateProjectTotalCount: (state, action: PayloadAction<number>) => {
      state.projectsTotalCount = action.payload;
    },
    updateProjectsItems: (state, action: PayloadAction<ProjectItem[]>) => {
      state.projectsItems = action.payload;
    },
    updateCurrentSourcePage: (state, action: PayloadAction<string>) => {
      state.currentSourcePage = action.payload;
    },
    updateCurrentKeyword: (state, action: PayloadAction<string>) => {
      state.currentKeyword = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(hydrate, (state, action) => {
      return { ...state, ...action.payload.search };
    });
  },
});

export const {
  updateLoadingProjectCarousel,
  updateProjectTotalCount,
  updateProjectsItems,
  updateCurrentSourcePage,
  updateCurrentKeyword,
} = searchSlice.actions;

export default searchSlice.reducer;
